module.exports = __webpack_public_path__ + "fonts/noto-ikea-latin.12a81d5b.ttf";